<div class="preview-wrapper">
    <div *ngIf="isAdblockDetected" class="block-info">
        <mat-icon class="block-info__icon">block</mat-icon>
        <div class="block-info__text">Wyłącz AdBlocka, jeśli chcesz zobaczyć podgląd kreacji.</div>
    </div>
    <div *ngIf="!isAdblockDetected" [attr.id]="uniqueId" class="ad-preview-slot" (window:resize)="onWindowResize()">
        <app-loader/>
    </div>
</div>
